import React from 'react';
import './reqInfo.scss';

const renderHeaderAdds = (headerAdds) => {
  if(!headerAdds || headerAdds.length === 0) return null;
  return (
      <div className="req-info__header-adds">
          {headerAdds.map((add, i) => (
              <div key={i} className="req-info__header-add">
                  {add}
              </div>
          ))}
      </div>
  )

};

const renderTitle = (title) => {
    if(!title) return null;
    return <h3 className="req-info__title">{title}</h3>;
};

const renderHeader = (title, headerAdds) => {
    if(!title && (!headerAdds || headerAdds.length === 0)) return null;
    return (
        <div className="req-info__header">
            {renderTitle(title)}
            {renderHeaderAdds(headerAdds)}
        </div>
    );
};

const renderContent = (content) => {
    if(!content) return null;
    return (
        <div className="req-info__content">
            {content}
        </div>
    );
}

const ReqInfo = (props) => {
    const {title, headerAdds} = props;
    return (
        <div className="req-info">
            {renderHeader(title, headerAdds)}
            {renderContent(props.children)}
        </div>
    )
};

export default ReqInfo;